var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrantAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#72C420"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57 19.0781H15.415L16.7867 17.0031C16.9784 16.724 17.2371 16.4973 17.539 16.3439C17.8409 16.1905 18.1765 16.1151 18.515 16.1248H22.6633L18.4367 22.5031C18.2448 22.7821 17.9861 23.0085 17.6842 23.1616C17.3822 23.3148 17.0467 23.3898 16.7083 23.3798H11.2667L5.5 15.7315L8.415 11.3365C9.52 9.66979 11.415 8.70312 13.5983 8.70312H27.5817L25.3133 12.1298C25.1208 12.4086 24.8614 12.6347 24.5589 12.7873C24.2563 12.9398 23.9203 13.0141 23.5817 13.0031H12.5817L8.57 19.0781Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3275 14.0898C14.2994 14.5773 14.4549 15.0577 14.7634 15.4362C15.0719 15.8147 15.511 16.064 15.9941 16.1348C15.4456 16.2335 14.9326 16.4742 14.5062 16.833C14.0798 17.1919 13.755 17.6563 13.5641 18.1798C13.5922 17.6923 13.4367 17.212 13.1282 16.8335C12.8197 16.4549 12.3806 16.2057 11.8975 16.1348C12.446 16.0362 12.959 15.7955 13.3854 15.4366C13.8118 15.0778 14.1366 14.6134 14.3275 14.0898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantAiLogo);
export default __webpack_public_path__ + "static/media/grantAi-logo.bdb2128344b52208c6fc98730240a8e7.svg";
export { ForwardRef as ReactComponent };